export const SET_AGENT_ID = 'SET_AGENT_ID'
export const SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD'
export const SET_PAYMENT_METHOD_DISCOUNT = 'SET_PAYMENT_METHOD_DISCOUNT'
export const SET_RECEIPT_CARRIER = 'SET_RECEIPT_CARRIER'
export const SET_RECEIPT_CARRIER_ID = 'SET_RECECARRIER_ID'
export const SET_TAX_ID = 'SET_TAX_ID'
export const SET_INVOICE_TITLE = 'SET_INVOICE_TITLE'
export const SET_DINING_PREFERENCE = 'SET_DINING_PREFERENCE'
export const SET_TABLE_NUMBERS = 'SET_TABLE_NUMBERS'
export const SET_TABLE_NUMBER = 'SET_TABLE_NUMBER'
export const SET_PHONE_NUMBER = 'SET_PHONE_NUMBER'
export const SET_PICKUP_TIME = 'SET_PICKUP_TIME'
export const SET_QR_CODE = 'SET_QR_CODE'
export const SET_NICKNAME = 'SET_NICKNAME'
export const SET_STORE = 'SET_STORE'
export const SET_MENU_URL = 'SET_MENU_URL'
export const SET_MENU_VARIATION = 'SET_MENU_VARIATION'
export const SET_ORDER_PARAMS = 'SET_ORDER_PARAMS'
export const RESET_ORDER_PARAMS = 'RESET_ORDER_PARAMS'

export const SET_BUSINESS_HOURS = 'SET_BUSINESS_HOURS'
